import PropTypes from 'prop-types';

const routerPropTypes = PropTypes.shape({
  route: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequred,
      search: PropTypes.string.isRequred,
    }),
  }),
});

const contextTypes = {
  bebopApi: PropTypes.object,
  ugcApi: PropTypes.object,
  servicesApi: PropTypes.object,
  router: routerPropTypes,
};


/**
 * TODO:
 * clean up $-prefixed values that were removed from here
 */

export default function resolve() {
  return function resolveHOC(Component) {
    function Resolver(props, context) {
      return (
        <Component
          {...props}
          {...context}
        />
      );
    }

    Resolver.contextTypes = contextTypes;

    return Resolver;
  };
}
